import { render, staticRenderFns } from "./WriteDoctor.vue?vue&type=template&id=3fcdc01e&scoped=true"
import script from "./WriteDoctor.vue?vue&type=script&lang=js"
export * from "./WriteDoctor.vue?vue&type=script&lang=js"
import style0 from "./WriteDoctor.vue?vue&type=style&index=0&id=3fcdc01e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcdc01e",
  null
  
)

export default component.exports